module.exports = __webpack_public_path__ + "static/media/S1_00042.b9afb7ae.jpg";